export default __webpack_public_path__ + "static/media/basicDetails.02812f3c.png";